import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";
import type {
  ServiceUserWebhookSecret,
  ServiceUserWebhookSecretCreated,
} from "@/api/types";

const webhookKey = (id: string) =>
  ["service-users", id, "webhook-secret"] as const;

export function useServiceUserWebhookSecret(id: string) {
  return useQuery({
    queryKey: webhookKey(id),
    queryFn: () =>
      api.GET<ServiceUserWebhookSecret>(
        `/service-users/${id}/webhook-secret`,
      ),
    enabled: Boolean(id),
  });
}

export function useSetServiceUserWebhookSecret(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api.POST<ServiceUserWebhookSecretCreated>(
        `/service-users/${id}/webhook-secret`,
        {},
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: webhookKey(id) });
    },
  });
}

export function useDeleteServiceUserWebhookSecret(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api.DELETE<void>(`/service-users/${id}/webhook-secret`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: webhookKey(id) });
    },
  });
}
